export function formatTry(n) {
  if (n == null || n === '' || !Number.isFinite(Number(n))) return '—';
  return Number(n).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺';
}

export function formatPct(n) {
  if (n == null || !Number.isFinite(Number(n))) return '—';
  return `%${Number(n).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function formatDeltaPct(n) {
  if (n == null || !Number.isFinite(Number(n))) return null;
  const abs = Math.abs(n).toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
  if (n > 0) return `↑ %${abs}`;
  if (n < 0) return `↓ %${abs}`;
  return '%0,0';
}
